import * as React from "react";

import {LicenseStore} from "../App";

import {observer} from "mobx-react";

import Axios from "axios";
import {RNTextInput} from "shared/controls/SingleInputs/RNTextInput";
import {SpinnerButton} from "shared/controls/SpinnerButton";
import {ToastService} from "shared/utilities/services/ToastService";
import {WpAjaxPost} from "shared/utilities/ajax/WPAjaxPost";


@observer
export class LicenseTab extends React.Component<LicenseTabProps, LicenseTabState> {
    static defaultProps: Partial<LicenseTabProps> = {};

    constructor(props: LicenseTabProps) {
        super(props);
        this.state = {
            LicenseIsActive:this.props.store.LicenseKey!='',
            Processing:false
        };
    }

    public render() {
        return (
            <React.Fragment>
                <RNTextInput<LicenseStore> Store={this.props.store} PropertyName={"LicenseKey"} Label={'License Key'} disabled={this.state.LicenseIsActive} />
                <SpinnerButton Icon={null} OnClick={()=>this.ToggleActivation()} disabled={this.props.store.LicenseKey==''} className={'rnbtn-primary'} IsBusy={this.state.Processing}>{this.state.LicenseIsActive?'Deactivate':'Activate'}</SpinnerButton>
            </React.Fragment>
        )
    }

    private async ToggleActivation() {
        if(!this.state.LicenseIsActive)
            this.ActivateLicense();
        else
            this.DeactivateLicense();


    }

    private ActivateLicense() {
        this.setState({Processing:true});
        let licenseKey=this.props.store.LicenseKey;
        Axios.get(`https://pdfbuilder.rednao.com/?edd_action=activate_license&item_id=${rednaoSettingsParams.ItemId}&license=${this.props.store.LicenseKey}&url=${rednaoSettingsParams.BaseUrl}`).then(async result=>{
            if(result.status!=200)
            {
                ToastService.SendErrorMessage('An unexpected error occurred, please try again');
                this.setState({Processing:false});
                return;
            }

            if (result.data.license!='valid') {
                this.setState({Processing:false});
                ToastService.SendErrorMessage('Invalid license!');
                return;
            }
            Axios.get(`https://pdfbuilder.rednao.com/?edd_action=check_license&item_id=${rednaoSettingsParams.ItemId}&license=${licenseKey}`).then(async result2=> {

                if(result2.status!=200)
                {
                    ToastService.SendErrorMessage('An unexpected error occurred, please try again');
                    this.setState({Processing:false});
                    return;
                }
                let expirationDate=new Date(result2.data.expires);
                if(isNaN(expirationDate as any))
                {
                    ToastService.SendErrorMessage('An unexpected error occurred, please try again');
                    this.setState({Processing:false});
                    return;
                }
                let result = await WpAjaxPost.Post('activate_license', {LicenseKey: licenseKey,ExpirationDate:expirationDate.getTime()/1000,URL:rednaoSettingsParams.BaseUrl});
                this.setState({Processing: false});
                if (result == null)
                    return;

                this.props.store.LicenseKey = licenseKey;
                rednaoSettingsParams.LicenseURL=rednaoSettingsParams.BaseUrl;
                ToastService.SendSuccess('License activated successfully');
                this.setState({
                    Processing:false,
                    LicenseIsActive:true
                })
            });
        });
    }

    private DeactivateLicense() {
        this.setState({Processing: true});
        Axios.get(`https://pdfbuilder.rednao.com/?edd_action=deactivate_license&item_id=${rednaoSettingsParams.ItemId}&license=${this.props.store.LicenseKey}&url=${rednaoSettingsParams.LicenseURL}`).then(async result=> {
            if (result.status != 200) {
                ToastService.SendErrorMessage('An unexpected error occurred, please try again');
                this.setState({Processing: false});
                return;
            }

            if (!result.data.success) {
                ToastService.SendErrorMessage('The license could not be deactivated! please try again');
                this.setState({Processing: false});
                return;
            }


            let result2 = await WpAjaxPost.Post('deactivate_license');
            this.setState({Processing: false});
            if (result2 == null)
                return;

            this.setState({LicenseIsActive:false});

            ToastService.SendSuccess('License deactivated successfully');

            rednaoSettingsParams.LicenseURL='';
            this.props.store.LicenseKey='';
        });
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface LicenseTabProps {
    store:LicenseStore;
}

interface LicenseTabState {
    LicenseIsActive:boolean;
    Processing:boolean;
}

//#endregion "My Region"